module.exports = __webpack_public_path__ + "static/img/fad.5091961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fad.png
// module id = xhBB
// module chunks = 1